import { Controller } from "@hotwired/stimulus"

// Reloads the wrapped <turbo-frame> on an interval while data-running="true".
// Attached to the frame itself; clears the interval on disconnect.
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 } }

  connect() {
    if (this.element.dataset.running !== "true") return
    this.timer = setInterval(() => {
      if (this.element.dataset.running !== "true") {
        clearInterval(this.timer)
        return
      }
      this.element.reload()
    }, this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }
}
